import * as actionTypes from './actionTypes';
import { PaymentTypeModel } from '@app/src/views/CipReport/filter/models/PaymentType';
import * as actionTypesSidebar from '@app/src/commons/sidebar/state/sidebar/actionTypes';

interface State {
  data: PaymentTypeModel;
  isFetching: boolean;
  errorMessage: string;
  errorRol?: boolean;
}

const initialState = {
  data: {
    code: null,
    message: '',
    paymentType: []
  },
  isFetching: false,
  errorMessage: '',
  errorRol: false
};

export const paymentType = (state: State = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_PAYMENT_TYPE_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case actionTypes.FETCH_PAYMENT_TYPE_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.errorMessage,
        errorRol: action.errorRol
      };
    case actionTypes.FETCH_PAYMENT_TYPE_SUCCESS:
      return {
        ...state,
        data: action.data,
        isFetching: false,
        errorMessage: '',
        errorRol: false
      };
    case actionTypesSidebar.RESET_APP_STATE:
      return initialState;
    default:
      return state;
  }
};
